<script setup lang="ts">
import { defineProps } from "vue";

type Props = {
  status?: string;
  title: string;
  subTitle?: string;
};

defineProps<Props>();
</script>

<template>
  <div class="w-full flex items-center justify-center my-[24px]">
    <div class="flex flex-col items-center gap-5">
      <div>
        <img
          v-if="status === 'failed'"
          src="@/assets/failed-frame.svg"
          alt="Failed"
        />
        <img
          v-else-if="status === 'data-missing'"
          src="@/assets/data-missing-frame.svg"
          alt="Data missing"
        />
        <img
          v-else-if="status === 'waiting'"
          src="@/assets/waiting-frame.svg"
          alt="Waiting"
        />
        <img v-else src="@/assets/success-frame.svg" alt="Success" />
      </div>
      <div class="flex flex-col items-center">
        <h3
          class="text-primary-text-color text-[24px] leading-[26px] tracking-[0.01rem] font-bold"
        >
          {{ title }}
        </h3>
        <h4
          class="text-primary-text-color text-[24px] leading-[26px] tracking-[0.01rem] font-bold"
          v-if="subTitle"
        >
          {{ subTitle }}
        </h4>
      </div>
    </div>
  </div>
</template>
